export default __webpack_public_path__ + "static/media/avatar-lulu.d9bf09ca.webp";